import {
  createSanitizationProfile,
  htmlTagGroups,
} from 'utils/sanitizeHtml/utils/createSanitizationProfile/createSanitizationProfile';

import { transformTagA } from '../../utils/transformTags';

/**
 * Represents the WhatsApp channel specific sanitization profile.
 *
 * Note that this should be kept in sync with
 * https://faq.whatsapp.com/general/chats/how-to-format-your-messages/?lang=en
 */
export const whatsAppSanitizationProfile = createSanitizationProfile({
  allowedTags: [
    ...htmlTagGroups.italic,
    ...htmlTagGroups.bold,
    ...htmlTagGroups.strikethrough,
    ...htmlTagGroups.inlineCode,
    ...htmlTagGroups.list,
    'a',
  ],
  allowedAttributes: {
    a: ['href'],
  },
  transformTags: {
    a: transformTagA,
  },
});
